import { render } from "./templateGameSuccessMaslenica.vue?vue&type=template&id=7b36fa41&scoped=true"
import script from "./templateGameSuccessMaslenica.vue?vue&type=script&lang=js"
export * from "./templateGameSuccessMaslenica.vue?vue&type=script&lang=js"

import "./templateGameSuccessMaslenica.vue?vue&type=style&index=0&id=7b36fa41&scoped=true&lang=css"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b36fa41"]])

export default __exports__